import React from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ChevronLeft } from 'lucide-react';

// Yup validation schema
  const schema = yup.object().shape({
    email: yup.string().email("Invalid email format").required("Email is required"),
  });

  function ForgotPassword() {
    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors } } = useForm({
      resolver: yupResolver(schema),
    });

    const onSubmit = (data) => {
      toast.success("OTP has been sent to your email.");
     };

    const handleGoBack = () => {
      navigate(-1);
    };

  return (
    <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
      <div className="relative">
        <div className="h-screen overflow-y-auto p-4 pb-20 max-w-sm min-w-[375px] w-full bg-white">
          <div className="flex flex-col h-full">
            <span className="text-gray-700 font-bold mt-[10px] mb-[60px] -ml-[5px]">
              <ChevronLeft size={20} onClick={handleGoBack} />
            </span>
            <img
              className="mb-5 max-w-full h-auto align-top"
               src={`${process.env.PUBLIC_URL}/th-303574540.jpg`}
              alt="logo"
            />
            <p className="text-[20px] mb-5 leading-[24px] font-bold font-lato">
              Forgot Password
            </p>

            <p className="text-gray-500 text-base mb-30 font-lato leading-[22px]">
              Don’t worry! It happens. Please enter your email, and we will send the OTP to this address.
            </p>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mt-5">
                <label className="text-[14px] leading-[21px] text-gray-700 font-lato mb-2 block" htmlFor="email">
                  Email
                </label>
                <input
                  placeholder="name@example.com"
                  type="email"
                  id="email"
                  {...register("email")}
                  className="w-full bg-gray-300 focus:border-blue-300 focus:outline-none rounded-md px-4 py-2"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
                )}
              </div>

              <div className="mt-3 mb-30">
                <button
                  type="submit"
                  className="bg-[#536895] w-full border border-[#536895] rounded-lg text-white text-base font-semibold py-3 px-12"
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default ForgotPassword;